module.exports = __webpack_public_path__ + "img/3_119.47f9b96c.png";